<template>
  <div ref="rootEl" :style="placeholderStyle">
    <slot v-if="shouldRender" />
    <slot v-else name="fallback" />
  </div>
</template>

<script setup lang="ts">
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';

const props = withDefaults(
  defineProps<{
    minHeight?: string;
    rootMargin?: string;
  }>(),
  {
    minHeight: '1px',
    rootMargin: '0px 0px'
  }
);

const rootEl = ref<HTMLElement | null>(null);
const shouldRender = ref(false);
let observer: IntersectionObserver | null = null;

const placeholderStyle = computed(() =>
  shouldRender.value ? undefined : { minHeight: props.minHeight }
);

onMounted(async () => {
  await nextTick();

  if (!rootEl.value || !('IntersectionObserver' in window)) {
    shouldRender.value = true;
    return;
  }

  observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry?.isIntersecting) return;
      shouldRender.value = true;
      observer?.disconnect();
      observer = null;
    },
    { rootMargin: props.rootMargin }
  );

  observer.observe(rootEl.value);
});

onBeforeUnmount(() => {
  observer?.disconnect();
  observer = null;
});
</script>
